<template>
  <v-container>
    <v-row>
      <v-col
        cols="12"
        xs="12"
        sm="6" offset-sm="2"
        md="4" offset-md="4"
        lg="4" offset-lg="4"
        xl="4" offset-xl="4">
        <div class="text-h2 text-center primary--text" d-block color="primary">
          {{ $t('welcome.title') }}
        </div>
        <div class="text-subtitle-1 text-center mt-10" d-block>
          {{ $t('welcome.subtitle') }}
        </div>
        <div class="text-subtitle-1 text-center mt-10" d-block>
          {{ $t('welcome.registerTitle') }}
        </div>
        <v-btn block color="success" :to="{ name: 'auth-Register' }">
          <v-icon class="mr-2">{{ mdiAccountPlus }}</v-icon>
          {{ $t('welcome.register') }}
        </v-btn>
        <div class="text-subtitle-1 text-center mt-10">{{ $t('welcome.loginTitle') }}</div>
        <v-btn block color="secondary" :to="{ name: 'auth-Login' }">
          <v-icon class="mr-2">{{ mdiAccountCheck }}</v-icon>
          {{ $t('welcome.login') }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { mdiAccountPlus, mdiAccountCheck } from '@mdi/js';
// import LottieAnimation from 'lottie-vuejs/src/LottieAnimation.vue';

export default {
  name: 'Welcome',
  data() {
    return {
      mdiAccountPlus,
      mdiAccountCheck,
    };
  },
  mounted() {
    if (this.isLoggedIn) {
      this.$router.push({ name: 'AuthHome' });
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
  },
};
</script>
